/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { Organization } from '@app/app/shared/models';
import { UserAuthState } from '@app/app/user-auth/store/user-auth.state';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class ShareUrlService {
  private readonly organization = toSignal(inject(Store).select(UserAuthState.organizationDetails));

  buildOrganizationEntityUrl(organization: Pick<Organization, 'domain'>, currentUrl: string, fallbackPath: string): string {
    const entityPath = NestedPathHelper.parsePath(currentUrl)?.fullPath ?? fallbackPath;

    return this.buildOrganizationUrl(organization, entityPath);
  }

  /** Falls back to the page's own origin until the organisation's domain has loaded; a computed reading it updates then. */
  buildShareableUrl(path: string): string {
    const organization = this.organization();
    return organization?.domain ? this.buildOrganizationUrl(organization, path) : new URL(path, window.location.origin).toString();
  }

  buildOrganizationUrl(organization: Pick<Organization, 'domain'>, path: string): string {
    const domain = organization.domain
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/, '');
    const normalizedPath = path.replace(/^\/+/, '');

    return `https://${domain}/${normalizedPath}`;
  }
}
